module.exports = __webpack_public_path__ + "static/media/opposition-3.15054ac7.png";